import React from 'react'
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import strRev from './assets/strRev.jpg'
import srt from './assets/Srt.png'
import buy from './assets/buy.jpg'
import Egg from './assets/egg.jpg'
import stkq from './assets/stkq.png'
import or from './assets/or.jpg'
import cn from './assets/cn.png'
import nrc from './assets/nrc.jpg'
import tdm from './assets/tdm.png'
import sum from './assets/sum.jpg'
import mes from './assets/mes.png'
import fls from './assets/fls.jpg'
import yShaped from './assets/yShaped.gif'
import cbt from './assets/cbt.png'
import arrEq from './assets/arrEq.png'
const Ind = () => {
    return (
        <div>
               <div class="cards-list" data-aos="fade-down" data-aos-delay="100">
  
  <div class="card 1">
    <div class="card_image"> <img src={strRev}/> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Reverse words in a given string</p>
      <NavLink to='/category/Goldman Sachs Interview question 1'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 2">
    <div class="card_image">
      
      <img src={or} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Overlapping rectangles</p>
      <NavLink to='/category/Goldman Sachs Interview question 2'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 1">
    <div class="card_image">
      <img src={cn} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Column name from a given column number</p>
        <NavLink to='/category/Goldman Sachs Interview question 3'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 2">
    <div class="card_image">
      <img src={nrc} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Non Repeating Character</p>
      <NavLink to='/category/Goldman Sachs Interview question 4'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={tdm} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Total Decoding Messages</p>
      <NavLink to='/category/Goldman Sachs Interview question 5'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={sum} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Sum Tree</p>
      <NavLink to='/category/Goldman Sachs Interview question 6'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={mes} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Get minimum element from stack</p>
        <NavLink to='/category/Goldman Sachs Interview question 7'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={fls} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Flattening a Linked List</p>
      <NavLink to='/category/Goldman Sachs Interview question 8'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={srt} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Sort a stack using Recursion</p>
      <NavLink to='/category/Goldman Sachs Interview question 9'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={yShaped} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Intersection Point in Y Shapped Linked Lists</p>
      <NavLink to='/category/Goldman Sachs Interview question 10'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={buy} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Stock buy and sell</p>
        <NavLink to='/category/Goldman Sachs Interview question 11'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
    <div class="card 4">
    <div class="card_image">
      <img src={Egg} />
      </div>
    <div class="card_title title-black">
      <p style={{fontSize:'1rem'}}>Egg Dropping Puzzle</p>
      <NavLink to='/category/Goldman Sachs Interview question 12'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
    </div>
   
    </div>
          <div class="cards-list"data-aos="fade-down" data-aos-delay="100">
    
  <div class="card 3">
    <div class="card_image"> <img src={cbt} /> </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Check for Balanced Tree</p>
      <NavLink to='/category/Goldman Sachs Interview question 13'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
    <div class="card 4">
    <div class="card_image">
      <img src={arrEq} />
      </div>
    <div class="card_title title-white">
      <p style={{fontSize:'1rem'}}>Check if two arrays are equal or not</p>
      <NavLink to='/category/Goldman Sachs Interview question 14'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
  
  <div class="card 3">
    <div class="card_image">
      <img src={stkq} />
    </div>
    <div class="card_title">
        <p style={{fontSize:'1rem'}}>Implement Queue using Stacks</p>
        <NavLink to='/category/Goldman Sachs Interview question 15'>
    <Button  variant="contained" color="primary" >
          Dive-In
        </Button></NavLink>
    </div>
  </div>
    
   
    </div>
        </div>
    )
}

export default Ind
